import { filter, ignoreElements, tap } from "rxjs/operators";
import { IdEventSoundCore } from "../../../utils/sound/IdEventSoundCore";
import { utilSound } from "../../../utils/sound/utilSound";
import { TypeActionBuildings } from "../../player-base/buildings/actionBuildings";
export var epicSoundsBuildingFinishMove = function (action$) {
    return action$.pipe(filter(function (action) { return action.type === TypeActionBuildings.FinishMove; }), tap(function () { return utilSound.event(IdEventSoundCore.BuildingFinishMove); }), ignoreElements());
};



//////////////////
// WEBPACK FOOTER
// ./src/features/sound/epics/epicSoundsBuildingFinishMove.ts
// module id = 2401
// module chunks = 3